module.exports = __webpack_public_path__ + "img/PHONE.9e43b49f.svg";